import { useEffect } from 'react';

const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title ? `EazyBilling - ${title}` : 'EazyBilling';
  }, [title]);
};

export default usePageTitle;
